import { Link } from 'react-router-dom'
import Title from '../../components/Title/Title'
import '../pages.css'
import styles from './NotFound.module.scss'

const NotFound = () => (
  <main className="page-container">
    <Title name="Сторінку не знайдено" />
    <section className={styles.content}>
      <p className={styles.code}>404</p>
      <p>Запитаної сторінки не існує або її було переміщено.</p>
      <Link className={styles.homeLink} to="/">Повернутися на головну</Link>
    </section>
  </main>
)

export default NotFound
